// useLetsPlayModal.js - Shared hook for Let's Play modal functionality
import { useState, useCallback } from 'react';

export const useLetsPlayModal = (user, onSessionLogged) => {
  // Common state from both Simplify and Collection
  const [showModal, setShowModal] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);
  const [showSessionForm, setShowSessionForm] = useState(false);
  const [showRulesSummary, setShowRulesSummary] = useState(false);

  // Common handlers
  const openModal = useCallback((game) => {
    setSelectedGame(game);
    setShowModal(true);
  }, []);

  const closeModal = useCallback(() => {
    setShowModal(false);
    setSelectedGame(null);
    setShowSessionForm(false);
    setShowRulesSummary(false);
  }, []);

  const logSession = useCallback(() => {
    setShowSessionForm(true);
  }, []);

  const showRules = useCallback(() => {
    setShowRulesSummary(true);
  }, []);

  const handleSessionLogged = useCallback((result) => {
    if (onSessionLogged) {
      onSessionLogged(result);
    }
    setShowSessionForm(false);
    setShowModal(false);
    setSelectedGame(null);
  }, [onSessionLogged]);

  return {
    // State
    showModal,
    selectedGame,
    showSessionForm,
    showRulesSummary,
    
    // Setters for fine-grained control
    setShowModal,
    setShowSessionForm,
    setShowRulesSummary,
    
    // Handlers
    handlers: {
      openModal,
      closeModal,
      logSession,
      showRules,
      handleSessionLogged
    }
  };
};
